import mirror from 'keymirror';
import Library from '../lib/library';
import UserFactory from '../lib/user-factory';
import { requestProgress } from './my-progress';

export const actionTypes = mirror({
  MY_PATH_SET_ERROR: null,
  MY_PATH_SET_IN_PROGRESS: null,
  MY_PATH_SET_SUCCESS: null,
  MY_PATH_PROGRESS_ERROR: null,
  MY_PATH_PROGRESS_IN_PROGRESS: null,
  MY_PATH_PROGRESS_SUCCESS: null,
});

const myPathSetError = response => ({
  response,
  type: actionTypes.MY_PATH_SET_ERROR,
});

const myPathSetInProgress = () => ({
  inProgress: true,
  type: actionTypes.MY_PATH_SET_IN_PROGRESS,
});

const myPathSetSuccess = response => ({
  response,
  type: actionTypes.MY_PATH_SET_SUCCESS,
});

const myPathProgressError = response => ({
  response,
  type: actionTypes.MY_PATH_PROGRESS_ERROR,
});

const myPathProgressInProgress = () => ({
  inProgress: true,
  type: actionTypes.MY_PATH_PROGRESS_IN_PROGRESS,
});

const myPathProgressSuccess = response => ({
  response,
  type: actionTypes.MY_PATH_PROGRESS_SUCCESS,
});

export function getPathProgress(pathID) {
  return async dispatch => {
    try {
      dispatch(myPathProgressInProgress());
      await requestProgress(pathID, 'paths', dispatch);
      dispatch(myPathProgressSuccess());
    } catch (err) {
      dispatch(myPathProgressError(err));
    }
  };
}

export const setMyPath = id => async (dispatch, getState) => {
  try {
    let pathId = id;
    if (!id) {
      const { fenderConnect } = getState();
      const pathResponse = await Library.getPathOnboarding();
      pathId = pathResponse.items[0].id;
      await UserFactory.updateProfile(fenderConnect.profile.id, { 'play-path-id': pathId });
    }
    dispatch(myPathSetInProgress());
    const path = await Library.getPathByID(pathId);
    dispatch(myPathSetSuccess(path));
  } catch (err) {
    dispatch(myPathSetError(err));
  }
};
